<div class="row top10">

  <div>
  <p>To Import {{ importType }} follow these steps: </p>
  <ol>
    <li>Create and download a spreadsheet.</li>
    <li>In the spreadsheet, fill in the values under the appropriate columns. Do not delete or change the first three rows.</li>
    <li>Import the spreadsheet back in to the system.</li>
    <li>Correct any data errors that are found.</li>
  </ol>

  </div>

    <div class="col-xs-12 text-center">
      <aims-common-button
            title="Generate Import Spreadsheet"
            aria-label="Generate Import Spreadsheet"
            (click)="generate()" >
            <mat-icon>table_chart</mat-icon>
            Create Spreadsheet
      </aims-common-button>

      <aims-common-button
            title="Import..."
            aria-label="Import..."
            (click)="import()" >
            <mat-icon>arrow_upward</mat-icon>
            Import...
      </aims-common-button>

      <div *ngIf="showFileUpload" style="margin: 20px;">
        <aims-file-upload name="importFile" style="margin-left: 10px;"
                      fileName={{importFileName}}
                      [saveUrl]="importPoint"
                      (success)="success($event)"
                      (error)="error($event)"
                      (uploaded)="uploaded()"
                      [allowedFileType]="allowedExtensions"
                      [maxFileSize]="maxFileSize">
        </aims-file-upload>
      </div>

    </div>

    <div class="col-xs-12 text-center" *ngIf="showResults">
      <h3> {{ result }} </h3>

      <ng-container *ngIf="importErrors.length > 0">
      <aims-common-table
        label="Errors"
        id="import-errors-table"
        [dataSource]="importErrors"
        [header]="errorsHeader"
        [permissions]="errorsPermissions"
        [stickyHeader]="true">
      </aims-common-table>
      </ng-container>
     </div>

  </div>

<aims-spinner spinnerText="processing..." [showSpinner]="showSpinner" ></aims-spinner>
